"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVersionCheckResultDtoPlatformEnum = void 0;
exports.instanceOfAppVersionCheckResultDto = instanceOfAppVersionCheckResultDto;
exports.AppVersionCheckResultDtoFromJSON = AppVersionCheckResultDtoFromJSON;
exports.AppVersionCheckResultDtoFromJSONTyped = AppVersionCheckResultDtoFromJSONTyped;
exports.AppVersionCheckResultDtoToJSON = AppVersionCheckResultDtoToJSON;
exports.AppVersionCheckResultDtoToJSONTyped = AppVersionCheckResultDtoToJSONTyped;
/**
 * @export
 */
exports.AppVersionCheckResultDtoPlatformEnum = {
    Ios: 'ios',
    Android: 'android'
};
/**
 * Check if a given object implements the AppVersionCheckResultDto interface.
 */
function instanceOfAppVersionCheckResultDto(value) {
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('minimumRequiredVersion' in value) || value['minimumRequiredVersion'] === undefined)
        return false;
    if (!('latestVersion' in value) || value['latestVersion'] === undefined)
        return false;
    if (!('appUrl' in value) || value['appUrl'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('isMandatoryUpdate' in value) || value['isMandatoryUpdate'] === undefined)
        return false;
    return true;
}
function AppVersionCheckResultDtoFromJSON(json) {
    return AppVersionCheckResultDtoFromJSONTyped(json, false);
}
function AppVersionCheckResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'platform': json['platform'],
        'minimumRequiredVersion': json['minimumRequiredVersion'],
        'latestVersion': json['latestVersion'],
        'appUrl': json['appUrl'],
        'message': json['message'],
        'isMandatoryUpdate': json['isMandatoryUpdate'],
    };
}
function AppVersionCheckResultDtoToJSON(json) {
    return AppVersionCheckResultDtoToJSONTyped(json, false);
}
function AppVersionCheckResultDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'platform': value['platform'],
        'minimumRequiredVersion': value['minimumRequiredVersion'],
        'latestVersion': value['latestVersion'],
        'appUrl': value['appUrl'],
        'message': value['message'],
        'isMandatoryUpdate': value['isMandatoryUpdate'],
    };
}
